import React from 'react';
import { Check } from 'lucide-react';
import { formatDateHebrewWithYear } from '../../../utils/dateUtils';

export const BookingSuccess = ({ service, date, timeSlot, onComplete }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50 p-4">
      <div className="max-w-md mx-auto pt-20">
        <div className="bg-white/70 backdrop-blur-sm border border-white/20 rounded-3xl p-8 shadow-2xl text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Check className="w-8 h-8 text-green-600" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">התור ממתין לאישור!</h2>
          <p className="text-gray-600 mb-6">התור שבחרת נקבע בהצלחה וממתין לאישור.</p>

          <div className="bg-gray-50 rounded-2xl p-4 mb-6 text-left">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 bg-gradient-to-br from-rose-100 to-pink-100 rounded-full flex items-center justify-center">
                <span className="text-rose-600 font-medium text-sm">
                  {timeSlot?.crewMemberName?.charAt(0)}
                </span>
              </div>
              <div>
                <p className="font-semibold text-gray-900">{service?.name}</p>
                <p className="text-sm text-gray-600">{timeSlot?.crewMemberName}</p>
              </div>
            </div>
            <div className="flex items-center gap-4 text-sm text-gray-500">
              <span>{formatDateHebrewWithYear(date)}</span>
              <span>•</span>
              <span>{timeSlot?.time}</span>
              <span>•</span>
              <span>{service?.duration}דקות</span>
            </div>
          </div>

          <button
            onClick={onComplete}
            className="w-full bg-gradient-to-r from-rose-500 to-pink-500 text-white py-3 rounded-2xl font-semibold hover:shadow-lg transition-all duration-300"
          >
            צפה בתורים שלך
          </button>
        </div>
      </div>
    </div>
  );
};
